import property from 'lodash/property';
import * as type from "./types";
import axios from "axios";
import {_convertStringDateToMomentObject, _sendLog} from "../../utils/utility";
import {_getCpToken} from "../system/service";

const authCpHeader = (state) => {
    const cpToken = _getCpToken(state);
    if (cpToken) {
        return { 'Authorization': 'Bearer ' + cpToken };
    } else {
        return {};
    }
}

export const _resetPolicy = () => {
    return (dispatch) => {
        dispatch({
            type: type.RESET_STATE
        })
    };
}


export const _storePolicy = (policy) => {
    return (dispatch) => {
        dispatch({
            type: type.POLICY_STORE,
            data: policy
        })
    };
}

export const _storePolicyList = (policyList) => {
    return (dispatch) => {
        dispatch({
            type: type.POLICY_LIST_STORE,
            data: policyList
        })
    }
}

export const _storeRequestList = (requestList) => {
    return (dispatch) => {
        dispatch({
            type: type.REQUEST_LIST_STORE,
            data: requestList
        })
    }
}

export const _storeRequest = (request) => {
    return (dispatch) => {
        dispatch({
            type: type.REQUEST_STORE,
            data: request
        })
    }
}
export const _storePoliciesForUpdate = (data, action = "") => {
    return (dispatch, getState) => {

        function pushMemberData(memberData) {
            policiesForUpdateList
                .filter(policy => policy.policyNumber === activePolicy.policyNumber)
                .map(policy => policy.members.push(memberData));
        }

        function handleDataForDeleteAndEdit (memberData) {
            if (!memberData.tempId) {
                pushMemberData(memberData);
            } else {
                policiesForUpdateList
                    .filter(policy => policy.policyNumber === activePolicy.policyNumber).map(policy => {
                    let memberList = policy.members;

                    let indexToRemove = policy.members.findIndex(member => member.tempId === policy.tempId);
                    if (indexToRemove >= 0) {
                        memberList.splice(indexToRemove,1);
                    }
                    memberList.push(memberData);
                    return policy;
                })
            }
        }

        let policy = {
            action: data.action,
            memberNo: data.memberNo,
            policyNumber: data.policyNumber,
            effectiveDate: _convertStringDateToMomentObject(data.effectiveDate),
            employmentDate: _convertStringDateToMomentObject(data.employmentDate),
            dateOfBirth: _convertStringDateToMomentObject(data.dateOfBirth),
            lastServiceDate: _convertStringDateToMomentObject(data.lastServiceDate),
            name: data.name,
            plan: data.planName,
            subsidiary: data.subsidiaryName,
            subsidiaryNo: data.subsidiaryNo,
            planId: data.planId,
            relationship: data.relationship,
            securityId: data.securityId,
            tempId: data.tempId,
            parentMember: data.parentMember,
            emailAddress: data.emailAddress,
            gender: data.gender
        }

        // add parentSecurityId only if existing
        if (data.parentSecurityId) {
            policy['parentSecurityId'] = data.parentSecurityId;
        }

        let activePolicy = _getPolicy(getState());
        let policiesForUpdateList = _getPoliciesForUpdate(getState());

        let specificPolicyForUpdate = policiesForUpdateList.filter((policy) =>
            policy.policyNumber === activePolicy.policyNumber);

        // if policy is existing already in the array
        if (specificPolicyForUpdate.length > 0) {
            if (action === 'A') {
                pushMemberData(policy);
            } else if (action === 'D') {
                if (policy.memberNo) {
                    handleDataForDeleteAndEdit(policy);
                } else {
                    // filter out the record with the same tempId as the active one
                    policiesForUpdateList
                        .filter(policy => policy.policyNumber === activePolicy.policyNumber).map(policy => {
                            let memberList = policy.members;
                            let indexToRemove = policy.members.findIndex(member => member.tempId === policy.tempId);
                            memberList.splice(indexToRemove,1);
                            return policy;
                    })
                }
            } else if ('E') {
                // change action to A if no memberNo
                if (!policy.memberNo) {
                    policy.action = 'A';
                }
                handleDataForDeleteAndEdit(policy);
            }
        } else {
            policiesForUpdateList.push(
                {
                    policyNumber: activePolicy.policyNumber,
                    members: [policy]
                }
            )
        }

        dispatch({
            type: type.STORE_POLICIES_FOR_UPDATE,
            data: policiesForUpdateList
        })
    }
}

export const _syncMemberList = (updatedMemberList) => {
    return (dispatch, getState) => {

        let policyList = _getPolicyList(getState());
        let activePolicy = _getPolicy(getState());

        policyList[activePolicy.policyIndex]
            .subsidiaryList[activePolicy.subsidiaryIndex]
            .planList[activePolicy.planIndex].memberList = (updatedMemberList.length === 0 ? [{}] : updatedMemberList);

        dispatch({
            type: type.POLICY_LIST_STORE,
            data: policyList
        })
    }
}

export const _storeMemberList = (subsidiaryNo, planId, memberList) => {
    return (dispatch, getState) => {

        let policyList = _getPolicyList(getState());
        let activePolicy = _getPolicy(getState());

        let subsidiaryIndex = 0;
        let planIndex = 0;
        // let memberList = [];
        policyList[activePolicy.policyIndex].subsidiaryList.map((sub, sindex) => {
            if (sub.subsidiaryNo === subsidiaryNo) {
                subsidiaryIndex = sindex;
                sub.planList.map((plan, pindex) => {
                    if (plan.planId === planId) {
                        planIndex = pindex;
                    }
                });
            }
        });
        policyList[activePolicy.policyIndex].subsidiaryList[subsidiaryIndex].planList[planIndex].memberList = memberList;

        dispatch({
            type: type.POLICY_LIST_STORE,
            data: policyList
        })
    }
}

export const _retrieveMemberList = (subsidiaryNo, planId) => {
    return (dispatch, getState) => {

        let policyList = _getPolicyList(getState());
        let activePolicy = _getPolicy(getState());

        policyList[activePolicy.policyIndex].subsidiaryList
            .filter(sub => sub.subsidiaryNo === subsidiaryNo).map(sub => {
            sub.planList.filter(plan => plan.planId === planId).map(plan => {
                return plan.memberList;
            });
        });
    }
}

export const _retrievePolicyList = () => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                timeout: 600000
            }

            console.log("_retrievePolicyList start");
            axios.get(process.env.REACT_APP_RETRIEVE_USER_POLICY_LIST, config)
                .then((response) => {
                    dispatch({
                        type: type.POLICY_LIST_STORE,
                        data: response.data.policyJsonList
                    });
                    resolve(response);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _retrievePolicyList', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _retrieveMembers = (planId) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                timeout: 600000,
                params: {
                    planId: planId
                }
            }
            console.log("_retrieveMembers for plan "+planId);
            axios.get(process.env.REACT_APP_RETRIEVE_MEMBERS_LIST, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _retrieveMembers', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _submitPolicy = (policy) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                timeout: 600000
            }
            axios.post(process.env.REACT_APP_SUBMIT_MEMBERS_LIST + '/' + policy.policyNumber, policy.members, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _submitPolicy', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _cancelPolicy = (policyNumber) => {
    return (dispatch, getState) => {

        // remove policy from policiesForUpdate
        let policiesForUpdate = _getPoliciesForUpdate(getState());
        policiesForUpdate = policiesForUpdate.filter(function(obj) {
            return obj.policyNumber !== policyNumber;
        })

        dispatch({
            type: type.STORE_POLICIES_FOR_UPDATE,
            data: policiesForUpdate
        })

        // remove members for all plans
        let policyList = _getPolicyList(getState());

        let policy = policyList.find((p) => {
                        return p.policyNumber === policyNumber
                    });

        policy.subsidiaryList.map(subsidiary => {
            subsidiary.planList.map(plan => {
                plan.memberList = [];
            })
        })
    }
}

export const _removePolicyFromUpdate = (policyNumber) => {
    return (dispatch, getState) => {

        let policiesForUpdate = _getPoliciesForUpdate(getState());
        policiesForUpdate = policiesForUpdate.filter(function(obj) {
            return obj.policyNumber !== policyNumber;
        })

        dispatch({
            type: type.STORE_POLICIES_FOR_UPDATE,
            data: policiesForUpdate
        })

    }
}

export const _retrieveRequests = () => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                timeout: 600000
            }
            axios.get(process.env.REACT_APP_RETRIEVE_REQUEST_LIST, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _retrieveRequests', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}


export const _retrieveRequestDetail = (requestId) => {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            let config = {
                headers: authCpHeader(getState()),
                timeout: 600000
            }
            console.log("_retrieveRequestDetail for user  "+requestId);
            axios.get(process.env.REACT_APP_RETRIEVE_REQUEST_DETAIL + '/' + requestId, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    _sendLog(['Corporate Portal React - Policy Service - _retrieveRequests', JSON.stringify(error)],
                        'error');
                    reject(error);
                })
        })
    }
}

export const _storeSubsidiaryList = (subsidiaryList) => {
    return (dispatch) => {
        dispatch({
            type: type.SUBSIDIARY_LIST_STORE,
            data: subsidiaryList
        })
    };
}

export const _storePlanList = (planList) => {
    return (dispatch) => {
        dispatch({
            type: type.PLAN_LIST_STORE,
            data: planList
        })
    }
}


export const _getPolicy = property('pl.policy');
export const _getPolicyList = property('pl.policyList');
export const _getPolicyReducerObject = property('pl');
export const _getPoliciesForUpdate = property('pl.policiesForUpdate');
export const _getPoliciesForRestore = property('pl.policyListRestore');
export const _getRequestList = property('pl.requestList');
export const _getRequest = property('pl.request');
export const _getSubsidiaryList = property('pl.subsidiaryList');
export const _getPlanList = property('pl.planList');
